import { useState } from "react";
import { SettingsSection } from "./SettingsSection";
import { PaymentRow } from "../Rows/PaymentRow";
import { SavePaymentModal } from "../Modals/SavePaymentModal";
import { AddButton } from "../Buttons/AddButton";
import {SaveBillingDetailsForm} from "../Form/Forms/Payment/SaveBillingDetailsForm"

export function Payments({ payments }) {
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [editingPaymentId, setEditingPaymentId] = useState(null);


  return (
    <>
      <SavePaymentModal open={openSaveModal} setOpen={setOpenSaveModal} />

      <SettingsSection title="Payment Methods">
        {payments?.length > 0 && (
          <ul className="space-y-4">
            {payments.map((p) => (
              <li key={p.id} className="space-y-2">
                {/* Payment row */}
                <PaymentRow
                  payment={p}
                  isEditing={editingPaymentId === p.id}
                  setEditingPaymentId={setEditingPaymentId}
                  canDelete={!p.inUse}
                />

                {/* Inline edit for billing info only */}
                {editingPaymentId === p.id && (
                  <div className="p-4 border border-gray-100 rounded-lg">
                    <SaveBillingDetailsForm
                      payment={p}
                      setOpen={() => setEditingPaymentId(null)}
                    />
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}

        <div className="mt-2 flex justify-start">
          <AddButton
            onClick={() => setOpenSaveModal(true)}
            text="Add another payment method"
          />
        </div>
      </SettingsSection>
    </>
  );
}